import React from "react";

function StatsBar({ stats, scene }) {
  return (
    <div className="vn-stats">
      <div className="vn-stat">
        Courage <span>{stats.courage}</span>/10
      </div>
      <div className="vn-stat">
        Sagesse <span>{stats.sagesse}</span>/10
      </div>
      <div className="vn-stat">
        Scène <span>{scene}</span>
      </div>
    </div>
  );
}

export default StatsBar;
